import { BookingUpdateOfferStatus, BookingUpdateOfferStatusLabels } from '@navio/nsdk';

export const getBookingUpdateOfferStatusLabel = (status: BookingUpdateOfferStatus): string => {
  switch (status) {
    case BookingUpdateOfferStatus.ACCEPTED:
      return BookingUpdateOfferStatusLabels.ACCEPTED;
    case BookingUpdateOfferStatus.DECLINED:
      return BookingUpdateOfferStatusLabels.DECLINED;
    case BookingUpdateOfferStatus.PENDING:
      return BookingUpdateOfferStatusLabels.PENDING;
    default:
      return status;
  }
};
